import { PrixiaPlayer } from '@/remotion/PrixiaPlayer';

export function VideoPage() {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#F1F5F9',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        gap: 32,
      }}
    >
      <h1
        style={{
          fontSize: 36,
          fontWeight: 800,
          color: '#1E293B',
          fontFamily: 'Inter, system-ui, sans-serif',
          textAlign: 'center',
          background: 'linear-gradient(135deg, #3B82F6, #8B5CF6)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}
      >
        Prixia — Video de Presentación
      </h1>

      <PrixiaPlayer autoPlay={false} controls loop={false} />

      <p
        style={{
          fontSize: 14,
          color: '#94A3B8',
          fontFamily: 'Inter, system-ui, sans-serif',
          textAlign: 'center',
          maxWidth: 500,
        }}
      >
        Usa los controles para reproducir. Para renderizar como MP4, ejecuta:{' '}
        <code
          style={{
            background: '#E2E8F0',
            padding: '2px 8px',
            borderRadius: 4,
            fontSize: 13,
          }}
        >
          npm run remotion:render
        </code>
      </p>
    </div>
  );
}
